import React, { PropsWithChildren } from 'react';
import { FormattedMessage } from 'react-intl';

import { htmlElements } from 'helpers/translations';
import DashboardSecurityLabel from 'components/DashboardSecurityLabel/DashboardSecurityLabel';

import BeginButton from '../shared/BeginButton';
import { Description } from '../shared/Description';

const StepBeginBase = ({ children }: PropsWithChildren) => (
  <>
    {children}

    <BeginButton />

    <Description>
      <FormattedMessage id="onboarding.stepBegin.description" values={htmlElements} />
    </Description>

    <DashboardSecurityLabel />
  </>
);

export default StepBeginBase;
